module.exports = __webpack_public_path__ + "static/media/deputy-1.58680558.png";